/**
 * Persistencia del contexto operativo de salesCounter para uso offline.
 *
 * Guarda en localStorage (namespaced por origin) el contexto resuelto cuando
 * hay conexión: cliente, punto de venta, método de pago, lista de precios,
 * tipo de comprobante, configuraciones, condiciones de IVA, staff y cajas.
 *
 * Al hacer F5 sin internet, loadConfigurations() falla y se rehidrata desde
 * acá, de modo que el operador pueda seguir facturando offline (los productos
 * viven en catalogStorage/IndexedDB y los tickets en localTicketCache).
 *
 * Se versiona por staff_id para no mezclar contextos entre usuarios del mismo
 * navegador.
 */

const KEY = window.location.origin + '_sales_counter_ctx'

const contextStorage = {
  save(snapshot) {
    try {
      localStorage.setItem(KEY, JSON.stringify(snapshot))
      return true
    } catch (e) {
      // localStorage lleno o no disponible: el offline F5 no tendrá fallback,
      // pero no debe romper el flujo online.
      return false
    }
  },

  /** Devuelve el snapshot guardado para el staff indicado, o null si no aplica */
  load(staffId) {
    try {
      const raw = localStorage.getItem(KEY)
      if (!raw) return null
      const snapshot = JSON.parse(raw)
      if (!snapshot) return null
      // Solo devolvemos el contexto si pertenece al staff actual.
      if (staffId && snapshot.staffId && parseInt(snapshot.staffId) !== parseInt(staffId)) {
        return null
      }
      return snapshot
    } catch (e) {
      return null
    }
  },

  clear() {
    try {
      localStorage.removeItem(KEY)
      return true
    } catch (e) {
      return false
    }
  },
}

export default contextStorage
